import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

interface IScrollToTopProps {
  children: React.ReactNode;
}

const ScrollToTop = ({ children }: IScrollToTopProps) => {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return children || null;
};

export default ScrollToTop;
